import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import fromNow from 'scaleflow/utils/from-now';
// import textDeltaIsEmpty from 'scaleflow/utils/text-delta-is-empty';

export default class InitiativesPopoverIndexComponent extends Component {
  @service initiativeSlideover;
  @service intl;
  @service betaToggle;

  @tracked activeTab = 'progress';

  get initiative() {
    return this.initiativeSlideover.initiative ?? {};
  }

  get slideoverIsOpen() {
    return this.initiativeSlideover.isOpen;
  }

  daysAgo(date) {
    return fromNow(date);
  }

  @action
  setActiveTab(tab) {
    this.activeTab = tab.key;
  }

  @action
  setInitiativeStatus(e) {
    this.initiative.status = e.value;
    this.initiative.save();
  }

  get tabs() {
    return [
      {
        label: this.intl.t('_initiatives.update', {
          num: 2,
        }),
        key: 'progress',
      },
      {
        label: this.intl.t('dictionary.back-of-napkin', { num: 1 }),
        key: 'bon',
      },
      {
        label: this.intl.t('dictionary.tasks'),
        key: 'tasks',
        link: 'backlog.initiatives.initiative.workstreams',
        hide:
          this.initiative.workstreams?.content?.length < 1 ||
          !this.betaToggle.showWorkstreams,
      },
    ];
  }

  get impact_widths() {
    const investment = this.initiative.bon_investment;
    const impact = this.initiative.bon_value;
    if (!investment && !impact) {
      return {
        investment_portion: `w-1/2`,
        impact_portion: `w-1/2`,
      };
    }

    if (+investment > +impact) {
      return {
        investment_portion: `w-4/5`,
        impact_portion: `w-1/5`,
      };
    }
    let investment_portion = Math.ceil((+investment / +impact) * 5);
    investment_portion = investment_portion === 5 ? 4 : investment_portion;
    const impact_portion = 5 - investment_portion;
    return {
      investment_portion: `w-${investment_portion}/5`,
      impact_portion: `w-${impact_portion}/5`,
    };
  }

  @action
  handleEscPress() {
    if (this.initiativeSlideover.updateWizardIsOpen) return;
    this.initiativeSlideover.close();
  }
}
